module.exports = __webpack_public_path__ + "img/infograph_4.d73d2d7a.png";